<template>
    <div class="feature-cards-container" :style="getContainerStyle()">
        <div class="rn-section-gap text-center color-white" v-if="showTitle">
            <div class="fs-1 w-700" v-if="showMainTitle">{{ mainTitle }}</div>
            <div class="fs-3" v-if="showSubTitle">{{ subTitle }}</div>
        </div>
        <div class="feature-cards-grid container" :class="gridClass">
            <div class="feature-card" v-for="(card, index) in cards" :key="index" :style="getCardStyle(card)"
                data-aos="fade-up" :data-aos-delay="index * 100">
                <div class="card-content">
                    <div class="card-icon" v-if="card.icon">
                        <img class="icon-default" :src="card.icon" :alt="card.title" />
                        <img class="icon-hover" v-if="card.icon1" :src="card.icon1" :alt="card.title" />
                    </div>
                    <div class="card-text">
                        <h4 class="card-title" v-if="card.title">{{ card.title }}</h4>
                        <p class="card-description fs-text" v-if="card.description">{{ card.description }}</p>
                    </div>
                </div>
                <!-- 悬浮背景图 -->
                <div class="card-hover-bg" v-if="card.backgroundImage1" :style="getHoverBgStyle(card)"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FeatureCards',
    props: {
        // 卡片数据
        cards: {
            type: Array,
            default: () => []
        },
        // 每行显示的列数
        columnsPerRow: {
            type: Number,
            default: 4,
            validator: value => [1, 2, 3, 4, 6].includes(value)
        },
        // 是否显示标题区域
        showTitle: {
            type: Boolean,
            default: true
        },
        // 是否显示主标题
        showMainTitle: {
            type: Boolean,
            default: true
        },
        // 是否显示副标题
        showSubTitle: {
            type: Boolean,
            default: true
        },
        // 主标题文本
        mainTitle: {
            type: String,
            default: '核心优势'
        },
        // 副标题文本
        subTitle: {
            type: String,
            default: '赋能业务增长、成就企业梦想'
        },
        // 默认背景图
        defaultBackground: {
            type: String,
            default: ''
        },
        // 背景图尺寸
        backgroundSize: {
            type: String,
            default: 'cover'
        },
        // 背景图位置
        backgroundPosition: {
            type: String,
            default: 'center'
        },
        // 背景图重复
        backgroundRepeat: {
            type: String,
            default: 'no-repeat'
        },
        // 卡片间距
        cardGap: {
            type: String,
            default: '20px'
        },
        // 卡片高度
        cardHeight: {
            type: String,
            default: 'auto'
        }
    },
    computed: {
        gridClass() {
            const columnMap = {
                1: 'col-12',
                2: 'col-lg-6 col-md-6 col-12',
                3: 'col-lg-4 col-md-6 col-12',
                4: 'col-lg-3 col-md-6 col-12',
                6: 'col-lg-2 col-md-4 col-12'
            }
            return `columns-${this.columnsPerRow}`
        }
    },
    methods: {
        getContainerStyle() {
            const style = {}

            // 如果有默认背景图，应用到容器上
            if (this.defaultBackground) {
                style.backgroundImage = `url(${this.defaultBackground})`
                style.backgroundSize = this.backgroundSize
                style.backgroundPosition = this.backgroundPosition
                style.backgroundRepeat = this.backgroundRepeat
            }

            return style
        },
        getCardStyle(card) {
            const style = {
                // height: this.cardHeight
            }
        
            // 如果单个卡片有背景图，使用卡片的背景图
            if (card && card.backgroundImage) {
                style.backgroundImage = `url(${card.backgroundImage})`
                style.backgroundSize = card.backgroundSize || '100% 100%'  // 改为 100% 100%
                style.backgroundPosition = card.backgroundPosition || 'center'
                style.backgroundRepeat = card.backgroundRepeat || 'no-repeat'
            }
        
            return style
        },
        getHoverBgStyle(card) {
            const style = {}
    
            if (card.backgroundImage1) {
                style.backgroundImage = `url(${card.backgroundImage1})`
                style.backgroundSize = card.backgroundSize || '100% 100%'  // 改为 100% 100%
                style.backgroundPosition = card.backgroundPosition || 'center'
                style.backgroundRepeat = card.backgroundRepeat || 'no-repeat'
            }
    
            return style
        }
    }
}
</script>

<style lang="scss" scoped>
.feature-cards-container {
    padding: 60px 0;
    min-height: 568px;

    .feature-cards-header {
        text-align: center;
        margin-bottom: 50px;

        .main-title {
            font-size: 2.5rem;
            font-weight: 600;
            color: #333;
            margin-bottom: 15px;

            @media (max-width: 768px) {
                font-size: 2rem;
            }
        }

        .sub-title {
            font-size: 1.2rem;
            color: #666;
            margin: 0;

            @media (max-width: 768px) {
                font-size: 1rem;
            }
        }
    }

    .feature-cards-grid {
        display: grid;
        gap: v-bind(cardGap);

        &.columns-1 {
            grid-template-columns: 1fr;
        }

        &.columns-2 {
            grid-template-columns: repeat(2, 1fr);

            @media (max-width: 768px) {
                grid-template-columns: 1fr;
            }
        }

        &.columns-3 {
            grid-template-columns: repeat(3, 1fr);

            @media (max-width: 992px) {
                grid-template-columns: repeat(2, 1fr);
            }

            @media (max-width: 768px) {
                grid-template-columns: 1fr;
            }
        }

        &.columns-4 {
            grid-template-columns: repeat(4, 1fr);

            @media (max-width: 1200px) {
                grid-template-columns: repeat(3, 1fr);
            }

            @media (max-width: 992px) {
                grid-template-columns: repeat(2, 1fr);
            }

            @media (max-width: 768px) {
                grid-template-columns: 1fr;
            }
        }

        &.columns-6 {
            grid-template-columns: repeat(6, 1fr);

            @media (max-width: 1400px) {
                grid-template-columns: repeat(4, 1fr);
            }

            @media (max-width: 1200px) {
                grid-template-columns: repeat(3, 1fr);
            }

            @media (max-width: 992px) {
                grid-template-columns: repeat(2, 1fr);
            }

            @media (max-width: 768px) {
                grid-template-columns: 1fr;
            }
        }
    }

    .feature-card {
        background: #fff;
        border-radius: 12px;
        padding: 30px 20px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
        min-height: 200px;
        display: flex;
        align-items: center;
        cursor: pointer;

        // 悬浮背景图
        .card-hover-bg {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0;
            transition: opacity 0.3s ease;
            z-index: 1;
        }

        &:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);

            // 显示悬浮背景
            .card-hover-bg {
                opacity: 1;
            }

            // 图标切换效果
            .card-icon {
                .icon-default {
                    opacity: 0;
                }

                .icon-hover {
                    opacity: 1;
                }
            }

            // 文字颜色变化
            .card-text {
                .card-title {
                    color: #ffffff !important;
                }

                .card-description {
                    color: #EFF3F6 !important;
                }
            }
        }

        .card-content {
            position: relative;
            z-index: 2;
            color: #fff;
            width: 100%;
            
            .card-icon {
                margin-bottom: 12px;
                position: relative;
                display: inline-block; // 确保容器有正确的尺寸
                width: 36px;
                height: 36px;
                
                img {
                    width: 36px;
                    height: 36px;
                    object-fit: contain;
                    transition: opacity 0.3s ease;
                    display: block; // 确保图片正确显示
                }
                
                .icon-default {
                    opacity: 1;
                    position: relative;
                    z-index: 1;
                }
                
                .icon-hover {
                    position: absolute;
                    top: 0;
                    left: 0; // 改为 left: 0 而不是 left: 50%
                    opacity: 0;
                    z-index: 2; // 确保悬浮图标在上层
                }
            }

            .card-text {
                .card-title {
                    font-size: 1.5rem;
                    margin-bottom: 10px;
                    font-family: PingFangSC-Semibold;
                    font-weight: 600;
                    color: #07274A;
                    transition: color 0.3s ease;
                    

                    @media (max-width: 768px) {
                        font-size: 1.4rem;
                    }
                }

                .card-description {
                    font-size: 1.2rem;
                    line-height: 1.6;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    color: #526177;
                    transition: color 0.3s ease;

                    @media (max-width: 768px) {
                        font-size: 1.2rem;
                    }
                }
            }
        }
    }
}
.feature-card {
    &:hover {
        .card-icon {
            .icon-default {
                display: none !important; // 强制隐藏
            }
            
            .icon-hover {
                display: block !important; // 强制显示
                opacity: 1 !important;
            }
        }
    }
    
    .card-icon {
        .icon-hover {
            display: none; // 默认隐藏
        }
    }
}
</style>